// Operational Engineering — unit constants & conversions.
//
// Single source of truth for the conversion factors used by every
// `lib/openg/formulas/*` module. Versioned so kill sheets can record which
// units engine produced their outputs (calculation provenance).

export const UNITS_VERSION = "openg-units/1.0";

// 1 ppg × 1 ft column = 0.052 psi (standard oilfield constant).
export const PRESSURE_GRADIENT_PPG_PSI_PER_FT = 0.052;

// 1 bbl = 5.6146 ft³ — used only inside annulus / capacity math; not part
// of the kill-sheet headline formulas.
export const FT3_PER_BBL = 5.6146;

// Helper: returns true if v is a finite, non-negative number.
export function isFiniteNum(v) {
  return v !== "" && v != null && Number.isFinite(Number(v));
}
export function asNum(v, fallback = NaN) {
  return isFiniteNum(v) ? Number(v) : fallback;
}
